import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 07D26BD5-0B09-4FAF-9710-DA1F19C40C39
 * name gamepad-round-left
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-left.svg
 * tags
 * - Gaming / RPG 
 */
export const GamepadRoundLeftIcon = createSvgIcon(<><path d="M4,8H8V4A2,2 0 0,1 10,2H14A2,2 0 0,1 16,4V8H20A2,2 0 0,1 22,10V14A2,2 0 0,1 20,16H16V20A2,2 0 0,1 14,22H10A2,2 0 0,1 8,20V16H4A2,2 0 0,1 2,14V10A2,2 0 0,1 4,8M4,10V14H8V10H4Z" /></>, 'GamepadRoundLeftIcon');
export default GamepadRoundLeftIcon